import CourseCurriculumBlockSectionPreview from "./CourseCurriculumBlockSectionPreview";

export default CourseCurriculumBlockSectionPreview;